import React from "react";
import ReactInputMask from "react-input-mask";
import Modal from "../../../../../_components/Modal";
import Text from "../../../../../_components/Text";
import { toast } from "react-toastify";
import Button from "../../../../../_components/Button";
import LoadingInput from "../../../../../_components/LoadingInput";
import StateLocation from "../../../../../_components/Address/StateLocation";
import CityLocation from "../../../../../_components/Address/CityLocation";
import { createTransporter, updateTransporter } from "../../../../../api/nfe";

export default (props) => {
	const ref = React.useRef(null);
	const [loading, setLoading] = React.useState(false);
	const [show, setShow] = React.useState(false);
	const [data, setData] = React.useState({ type: "pf" });

	function onHandleShow() {
		if (loading) {
			return;
		}
		if (show === true) {
			if (props.onHide) {
				props.onHide();
				setData({ type: "pf" });
				setShow(false);
			}
		} else {
			setShow(true);
		}
	}
	function onChange(e) {
		let { name, value } = e.target

		let tempData = { ...data }

		if (name == 'type') {
			tempData['cpf_cnpj'] = ''
		}

		if (["cpf_cnpj", "state_registry"].includes(name)) {
			const regex = /\D+/g; // regex to find anything but numbers
			value = value.replace(regex, '');
		}

		tempData[name] = value

		setData(tempData);
	}
	function setStateLocation(state_location, stateCode) {
		setData({
			...data,
			state_location,
			stateCode,
		});
	}
	function setCityLocation(city_location) {
		setData({
			...data,
			city_location: city_location.target.value,
		});
	}
	function onToast(message = "", type = "success") {
		const toastId = 2010;
		toast[type](message, {
			toastId,
			position: "top-center",
		});
	}
	function onSave() {
		let required = [
			"name",
			"cpf_cnpj",
			"state_location",
			"city_location",
			"street",
		].concat(data.type === "pj" ? ["state_registry"] : []);
		let errors = [];
		const toggleClass = (name, act) => {
			try {
				document.querySelector(`[name="${name}"]`).classList[act]("is-invalid");
			} catch (error) { }
		};

		/* 
		Map the required fields and show alerts if:
		  - Any of these fields are empty
		  Or
		  - Cpf or Cnpj aren't with the correct length
		*/
		for (let key of required) {
			if (!data[key]) {
				toggleClass(key, "add");
				errors.push("");
			} else if (key == "cpf_cnpj") {
				if (
					(data.type == "pf" && data[key].length != 11) ||
					(data.type == "pj" && data[key].length != 14)
				) {
					toggleClass(key, "add");
					errors.push("");
				}
			} else {
				toggleClass(key, "remove");
			}
		}
		if (errors.length > 0) {
			return;
		}
		setLoading(true);
		const request = data.id ? updateTransporter : createTransporter;
		request(data)
			.then((resp) => {
				onToast("Transportadora salva!");
				setTimeout(() => {
					location.reload();
				}, 2000);
			})
			.catch((error) => { })
			.finally(() => {
				setTimeout(() => {
					setLoading(false);
				}, 3000);
			});
	}
	function onShow() {
		if (props.show === true) {
			if (props.data) {
				const cpf_cnpj = props.data.cnpj || props.data.cpf;
				const type = cpf_cnpj ? (cpf_cnpj.length == 14 ? "pj" : "pf") : "pf";
				const state_location = props.data.state_location
					? props.data.state_location.id
					: "";
				const city_location = props.data.city_location
					? props.data.city_location.id
					: "";
				const state_name = state_location
					? props.data.state_location.state_name
					: "";
				const city_name = props.data.city_location
					? props.data.city_location.city_name
					: "";
				const stateCode = props.data.state_location
					? props.data.state_location.uf_code
					: null;

				setData({
					...props.data,
					cpf_cnpj,
					type,
					state_location,
					state_name,
					city_location,
					city_name,
					stateCode
				});
				setShow(true);
			}
		}
	}
	React.useEffect(onShow, [props.show]);
	return (
		<div ref={ref}>
			<Button onClick={onHandleShow}>Cadastrar Transportadora</Button>
			<Modal title="Transportadora" onHide={onHandleShow} show={show}>
				<div className="container">
					<div className="row">
						<div className="col-12">
							<div className="text-center m-0 py-3">
								<span className=""></span>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-6 col-xs-12">
							<div className="form-group">
								<div className="form-label">
									<Text color="primary">Tipo de transportadora</Text>
								</div>
								<LoadingInput
									as="select"
									onChange={onChange}
									name="type"
									loading={loading}
								>
									<option value="pj" selected={data.type === "pj"}>
										Pessoa Jurídica
									</option>
									<option value="pf" selected={data.type === "pf"}>
										Pessoa Física
									</option>
								</LoadingInput>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-4">
							<div className="form-group">
								<div className="form-label">
									<Text color="primary">
										Nome/Razão Social da transportadora
									</Text>
								</div>
								<LoadingInput
									loading={loading}
									name="name"
									onChange={onChange}
									value={data.name}
								/>
							</div>
						</div>
						<div className="col-md-4">
							<div className="form-group">
								<div className="form-label">
									<Text color="primary">
										{data.type === "pf" ? "CPF" : "CNPJ"} da transportadora
									</Text>
								</div>
								<ReactInputMask
									name="cpf_cnpj"
									onChange={onChange}
									value={data.cpf_cnpj}
									disabled={loading}
									mask={
										data.type === "pf" ? "999.999.999-99" : "99.999.999/9999-99"
									}
									className="form-control"
								/>
							</div>
						</div>
						<div className="col-md-4">
							<div className="form-group">
								<div className="form-label">
									<Text color="primary">Inscrição Estadual (IE)</Text>
								</div>
								<LoadingInput
									name="state_registry"
									loading={loading}
									onChange={onChange}
									value={data.state_registry}
								/>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-4">
							<StateLocation
								selected={data.state_name}
								disabled={loading}
								onChange={setStateLocation}
							/>
						</div>
						<div className="col-md-4">
							<CityLocation
								defaultInputValue={data.city_name}
								disabled={loading}
								onChange={setCityLocation}
								stateCode={data.stateCode}
							/>
						</div>
						<div className="col-md-4">
							<div className="form-group">
								<div className="form-label">
									<Text color="primary">Endereço</Text>
								</div>
								<LoadingInput
									loading={loading}
									name="street"
									onChange={onChange}
									value={data.street}
								/>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<div className="d-flex justify-content-center">
								<Button disabled={loading} onClick={onSave}>
									Salvar Transportadora
								</Button>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Transport/Transporter/index.jsx